<div *ngIf="output">
  <h3-output-warnings [outputName]="name"></h3-output-warnings>
</div>

<div
  *ngIf="isClearAnswerButtonVisible$ | async"
  [class.size-placeholder]="output?.required"
  class="position-relative"
>
  <div class="clear-button">
    <a (click)="resetOutput()">
      <mat-icon class="material-symbols-outlined" matTooltip="Clear"
        >cancel</mat-icon
      >
    </a>
  </div>
</div>

<div
  *ngIf="output?.required && (isClearAnswerButtonVisible$ | async) === false"
  class="all-caps required-label"
>
  Required
</div>

<div class="question-text padding-right"><ng-content></ng-content></div>
<div *ngIf="output" [class.padding-right]="isClearAnswerButtonVisible$ | async">
  <h3-naked-output [name]="name" (wheel)="onWheel($event)"></h3-naked-output>
  <h3-individual-field-scores [output]="output"></h3-individual-field-scores>
  @if (showFieldFeedbackFooter) {
    <h3-field-feedback-output-footer
      [output]="output"
    ></h3-field-feedback-output-footer>
  }
</div>
